/* eslint-disable react/no-danger */

import React, { PropTypes } from 'react';

import { gridBaseline } from '../../base-styles/vars';

import { button, container } from './styles.module.css';

// Base line height is a string var, e.g. '1.875rem', here we determine value and unit
// in order to calculate the element height in the component style object.
// Usually this is performed by postCSSSimpleVars in CSS files using calc().
const lineHeightValue = parseFloat(gridBaseline, 10);
const lineHeightUnit = gridBaseline.toLowerCase().match(/([a-z]+)$/g) || '';

/**
 * Read More presentational component.
 */
const ReadMore = ({ className, collapsed, content, html, lineCount, onClick, onRef }) => (
  <div
    className={[container, className].join(' ')}
    ref={onRef}
    style={{ maxHeight: collapsed ? `${lineCount * lineHeightValue}${lineHeightUnit}` : 'none' }}
  >
    {html ? <div dangerouslySetInnerHTML={{ __html: content }} /> : content}
    {collapsed && (
      <button type="button" onClick={onClick} className={button}>
        Read more
      </button>
    )}
  </div>
);

ReadMore.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  content: PropTypes.string.isRequired,
  html: PropTypes.bool,
  lineCount: PropTypes.number,
  onClick: PropTypes.func,
  onRef: PropTypes.func,
};

ReadMore.defaultProps = {
  className: '',
  collapsed: true,
  html: false,
  lineCount: 3,
  onClick: () => {},
  onRef: () => {},
};

export default ReadMore;



// WEBPACK FOOTER //
// ./app/src/components/ReadMore/component.jsx